import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";

class NavigationMobile {
  constructor(component) {
    this.refs = {
      toggle: '.js-navigation-mobile-toggle',
      close: '.js-navigation-mobile-close',
      accordion: '.js-navigation-mobile-accordion',
      accordionToggle: '.js-navigation-mobile-accordion-toggle',
      accordionContent: '.js-navigation-mobile-accordion-content',
      accordionIcon: '.js-navigation-mobile-accordion-icon',
      underlay: '.js-underlay',
      headerDrawer: '.js-navigation-mobile-header-drawer',
    };

    this.dom = {
      $component: component,
      $toggle: component.querySelector(this.refs.toggle),
      $close: component.querySelector(this.refs.close),
      $menu: component.querySelector('.js-navigation-mobile-menu'),
      $accordions: component.querySelectorAll(this.refs.accordion),
      $underlay: document.querySelector(this.refs.underlay),
      $headerDrawer: component.querySelector(this.refs.headerDrawer),
    };

    this.state = {
      navigationActive: false,
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      openMenuFallbackTimer: null,
      openMenuTransitionHandler: null,
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;

    if (dom.$toggle) {
      dom.$toggle.addEventListener('click', this.handleToggleClick.bind(this));
    }

    if (dom.$accordions) {
      dom.$accordions.forEach($el => {
        $el.addEventListener('click', this.handleAccordionClick.bind(this));
      });
    }

    if (dom.$underlay) {
      dom.$underlay.addEventListener('click', this.closeMenu.bind(this));
    }

    if (dom.$close) {
      dom.$close.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  handleAccordionClick(e) {
    const { refs, state } = this;

    const $accordion = e.currentTarget;
    const $button = $accordion.querySelector(refs.accordionToggle);
    const isExpanded = $button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeAccordion($accordion);
    } else {
      this.closeAllAccordions();
      this.openAccordion($accordion);
    }
  }

  openAccordion($accordion) {
    const { refs, state } = this;
    const $button = $accordion.querySelector(refs.accordionToggle);
    const $icon = $accordion.querySelector(refs.accordionIcon);
    const $content = $accordion.querySelector(refs.accordionContent);
    const targetId = $button.getAttribute('aria-controls');
    const contentHeight = $content.scrollHeight;
    const targetList = document.getElementById(targetId);

    targetList.style.height = `${contentHeight}px`;
    $button.setAttribute('aria-expanded', true);
    $icon.innerHTML = "-";
    $accordion.classList.add('is-active');

    state.accessibilityHelper.updateElementAccessibility($content, true);
  }

  closeAccordion($accordion) {
    const { refs, state } = this;
    const $button = $accordion.querySelector(refs.accordionToggle);
    const $icon = $accordion.querySelector(refs.accordionIcon);
    const $content = $accordion.querySelector(refs.accordionContent);
    const targetId = $button.getAttribute('aria-controls');
    const targetList = document.getElementById(targetId);

    targetList.style.height = "0";
    $button.setAttribute('aria-expanded', false);
    $icon.innerHTML = "+";
    $accordion.classList.remove('is-active');

    state.accessibilityHelper.updateElementAccessibility($content, false);
  }

  closeAllAccordions() {
    const { refs, dom, state } = this;

    dom.$accordions.forEach($el => {
      console.log('Closing accordion', $el);
      const $button = $el.querySelector(refs.accordionToggle);
      const $icon = $el.querySelector(refs.accordionIcon);
      const $content = $el.querySelector(refs.accordionContent);
      const targetId = $button.getAttribute('aria-controls');
      const targetList = document.getElementById(targetId);

      targetList.style.height = "0";
      $button.setAttribute('aria-expanded', false);
      $icon.innerHTML = "+";
      $el.classList.remove('is-active');

      state.accessibilityHelper.updateElementAccessibility($content, false);
    });
  }

  handleToggleClick() {
    const { state } = this;

    if (state.navigationActive) {
      return;
    }

    this.openMenu();
  }

  openMenu () {
    const { dom, state } = this;

    dom.$menu.classList.add('is-open');
    document.body.classList.add('scroll-locked');
    dom.$underlay.classList.add('is-active');

    const focusTrapElements = [dom.$headerDrawer, dom.$menu];
    state.focusTrap = state.accessibilityHelper.buildFocusTrap(focusTrapElements);
    state.navigationActive = true;
    state.accessibilityHelper.addEscapeKeyListener(this.closeMenu.bind(this));

    this.clearOpenMenuListeners();

    let transitionFired = false;

    const activateTrap = () => {
      if (transitionFired) return;
      transitionFired = true;

      this.clearOpenMenuListeners();

      if (!state.navigationActive) return;

      state.focusTrap.set();

      dom.$toggle.setAttribute('aria-hidden', 'true');
      dom.$toggle.setAttribute('tabindex', '-1');
      dom.$toggle.style.visibility = 'hidden';
    };

    state.openMenuTransitionHandler = () => activateTrap();

    // Fallback: if transitionend never fires (e.g. prefers-reduced-motion or transition:none),
    // run the same logic after a short safety timeout (350ms > 300ms transition).
    state.openMenuFallbackTimer = setTimeout(activateTrap, 350);

    dom.$menu.addEventListener('transitionend', state.openMenuTransitionHandler);
  }

  clearOpenMenuListeners() {
    const { dom, state } = this;

    if (state.openMenuFallbackTimer) {
      clearTimeout(state.openMenuFallbackTimer);
      state.openMenuFallbackTimer = null;
    }

    if (state.openMenuTransitionHandler) {
      dom.$menu.removeEventListener('transitionend', state.openMenuTransitionHandler);
      state.openMenuTransitionHandler = null;
    }
  }

  closeMenu () {
    const { dom, state } = this;

    if (!state.navigationActive) return;

    this.clearOpenMenuListeners();

    if (state.focusTrap) {
      state.focusTrap.unset();
      state.focusTrap = null;
    }

    dom.$menu.classList.remove('is-open');
    document.body.classList.remove('scroll-locked');
    dom.$underlay.classList.remove('is-active');
    state.navigationActive = false;

    // Remove escape key listener
    state.accessibilityHelper.removeEscapeKeyListener();

    // Restore open button
    if (dom.$toggle) {
      dom.$toggle.removeAttribute('aria-hidden');
      dom.$toggle.removeAttribute('tabindex');
      dom.$toggle.style.visibility = '';
      dom.$toggle.focus();
    }
  }
}

const $navigationMobile = document.querySelector('.js-navigation-mobile');
new NavigationMobile($navigationMobile);
